/**
 * payslip.ts (02.09, владелец: «сформировать расчётки… зловещая картинка в
 * киберпанковом стиле») — рендер расчётки оператора в PNG на клиенте (Canvas
 * 2D): шапка UNIBOOKING / РАСЧЁТКА / период / имя, «К ВЫПЛАТЕ» с неоновым
 * свечением, разбивка по видам, дни с цветными строками (игры золото / МК
 * свой цвет --mc (11.10, владелец: «для всего, что связано с мастер-классами, — новый, нигде
 * не употребляющийся цвет») / админство фуксия / допработы фиолет (11.10) / такси циан / покупки-компенсации
 * лайм (04.09, владелец: «обозначаются особым цветом») / премии синий
 * (05.09, владелец) / штрафы красный),
 * сетка, скан-линии, угловые скобки, глитч-полосы. Цвета — из CSS-токенов
 * приложения (getComputedStyle), шрифты — те же Orbitron/Rajdhani/Chakra
 * Petch (ждём document.fonts.ready). Высота холста — по числу строк.
 * 13.10 (архив 1С, ПР3): строки игр и МК, выплаченные через 1С, подписаны; такси отчёта 1С — «доп 1С».
 * 26.10 (владелец: «особо отмечать в расчётке»): премия или штраф с отметкой (mark, @ub/shared/slipMark) —
 * строка в рамке и со свечением своего цвета, «★» перед названием и плашка с подписью.
 */
import { PAID_1C_SHORT, TAXI_1C_LABEL, withPaid1c } from "@ub/shared/archive1c";
import { hasSlipMark, slipMarkLabel } from "@ub/shared/slipMark";
export interface PsQuest { quest_name?: string; short_name?: string; time?: string; rate?: number; zero_rate?: boolean; status?: string; taxi_amount?: number; has_report?: boolean; paid_1c?: boolean; taxi_1c?: boolean }
export interface PsMc { mc_name?: string; quest_short?: string; time?: string; rate?: number; paid_1c?: boolean }
export interface PsHa { branch?: string; branch_id?: string; hours?: number; rate?: number; earning?: number; /** 16.10: итог смены задан вручную */ fixed?: boolean }
export interface PsEw { time_from?: string; time_to?: string; description?: string; earning?: number; taxi?: number }
export interface PsPen { amount?: number; reason?: string; mark?: string | null }
/** Премия оператору (05.09): плюс к выплате, синим var(--blue). 26.10: mark — особая отметка. */
export interface PsBonus { amount?: number; reason?: string; mark?: string | null }
/** Покупка оператора, подтверждённая ОО (04.09): компенсация — не зарплата, но выплачивается вместе. */
export interface PsPurchase { amount?: number; description?: string; comment?: string | null }
export interface PsDay { quests?: PsQuest[]; mc?: PsMc[]; hall_admin?: PsHa | null; extra_work?: PsEw[]; purchases?: PsPurchase[]; bonuses?: PsBonus[]; penalties?: PsPen[]; day_total?: number }
export interface PsSal {
  staffId: string; name: string; total: number; games_count: number;
  quest_earnings: number; mc_earnings: number; hall_admin_earnings: number;
  extra_work_earnings: number; taxi_earnings: number; purchase_total?: number; bonus_total?: number; penalty_total?: number; days: Record<string, PsDay>;
  /** 16.10 (владелец: холд «в кабинете и в расчётке»): холд с прошлых недель (+ мы должны, − должен нам); 0/нет — блоков нет. */
  carry?: number;
}
export interface PsMeta { from: string; to: string; issuedBy: string; issuedAt: string }

const W = 1080;
const PAD = 64;
const NB = " ";
const money = (n: number) => `₽${String(Math.round(n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, NB)}`;
const WD = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
const dLabel = (iso: string) => { const d = new Date(`${iso}T12:00:00Z`); return `${iso.slice(8, 10)}.${iso.slice(5, 7)} ${WD[d.getUTCDay()]}`; };
const t5 = (t?: string) => (t ?? "").slice(0, 5);

function tok(name: string, fb: string): string {
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fb;
}
/* палитра — из токенов темы; фолбэки на случай отсутствия переменной */
function palette() {
  return {
    bg: tok("--bg", "#070a0f"), s1: tok("--surface-1", "#0d1218"), s2: tok("--surface-2", "#121a22"), s3: tok("--surface-3", "#1c2731"),
    t1: tok("--text-1", "#e8f1f8"), t2: tok("--text-2", "#9fb3c4"), t3: tok("--text-3", "#5f7385"),
    cyan: tok("--cyan", "#2ee6ff"), gold: tok("--gold", "#ffd84a"), purple: tok("--purple", "#a86bff"), pink: tok("--pink", "#ff4fd8"),
    orange: tok("--orange", "#ff9f1c"), red: tok("--red", "#ff4d5e"), green: tok("--green", "#39ff9e"),
    buy: tok("--lime", "#b8ff2e"), /* покупки — везде лайм (04.09) */
    bonus: tok("--blue", "#2d7aff"), /* премии — везде синий (05.09) */
    mc: tok("--mc", "#89aaf5"), /* мастер-классы — свой цвет (11.10) */
  };
}
const F = { display: '"Orbitron", "Chakra Petch", sans-serif', body: '"Rajdhani", "Chakra Petch", sans-serif', meta: '"Chakra Petch", sans-serif' };

/** mark — особая отметка (26.10): подпись или «» (одна звезда); нет поля — строка обычная. */
type Row = { kind: "q" | "t" | "m" | "a" | "e" | "b" | "n" | "p"; l: string; sub?: string; r: string; warn?: boolean; mark?: string };
const markOf = (m: unknown): string | undefined => (hasSlipMark(m) ? slipMarkLabel(m) : undefined);

/* МК того же квеста и времени — сразу под игрой (отзыв оператора 02.09);
   МК без своей игры у этого человека — отдельной строкой после игр. */
function mcRow(m: PsMc, attached: boolean): Row {
  return { kind: "m", l: `${attached ? "  ↳ " : `${t5(m.time)}  `}МК ${m.mc_name ?? ""}${!attached && m.quest_short ? ` · ${m.quest_short}` : ""}`, sub: m.paid_1c ? PAID_1C_SHORT : undefined, r: money(m.rate ?? 0) };
}
function dayRows(day: PsDay): Row[] {
  const rows: Row[] = [];
  const mcs = [...(day.mc ?? [])];
  const takeMc = (q: PsQuest) => {
    const i = mcs.findIndex((m) => (m.quest_short || "") === (q.short_name || "") && (!m.time || !q.time || t5(m.time) === t5(q.time)));
    return i >= 0 ? mcs.splice(i, 1)[0] : undefined;
  };
  for (const q of day.quests ?? []) {
    const cancelled = q.status === "cancelled";
    rows.push({ kind: "q", l: `${t5(q.time)}  ${q.short_name || q.quest_name || ""}`, sub: withPaid1c(cancelled ? "отмена · компенсация" : q.zero_rate ? "без ставки" : q.has_report === false ? "отчёт не сдан" : undefined, q.paid_1c), r: money(q.rate ?? 0), warn: !cancelled && q.has_report === false });
    for (let m = takeMc(q); m; m = takeMc(q)) rows.push(mcRow(m, true));
    if ((q.taxi_amount ?? 0) > 0) rows.push({ kind: "t", l: q.taxi_1c ? TAXI_1C_LABEL : "такси", sub: q.paid_1c ? PAID_1C_SHORT : undefined, r: money(q.taxi_amount ?? 0) });
  }
  for (const m of mcs) rows.push(mcRow(m, false));
  if (day.hall_admin) { const h = day.hall_admin; rows.push({ kind: "a", l: `Админство ${String(h.branch_id || h.branch || "").toUpperCase()}`, sub: h.fixed ? `${String(h.hours ?? 0).replace(".", ",")} ч · сумма задана вручную` : `${String(h.hours ?? 0).replace(".", ",")} ч × ${money(h.rate ?? 0)}/ч`, r: money(h.earning ?? 0) }); }
  for (const e of day.extra_work ?? []) {
    rows.push({ kind: "e", l: `Доп ${t5(e.time_from)}–${t5(e.time_to)}`, sub: (e.description ?? "").slice(0, 40) || undefined, r: money(e.earning ?? 0) });
    if ((e.taxi ?? 0) > 0) rows.push({ kind: "t", l: "такси", r: money(e.taxi ?? 0) });
  }
  /* покупки — после допработ, перед штрафами (04.09) */
  for (const b of day.purchases ?? []) rows.push({ kind: "b", l: "Покупка · компенсация", sub: (b.description ?? "").slice(0, 48) || undefined, r: money(b.amount ?? 0) });
  /* премии — после покупок, перед штрафами (05.09) */
  for (const n of day.bonuses ?? []) rows.push({ kind: "n", l: "Премия", sub: (n.reason ?? "").slice(0, 48) || undefined, r: money(n.amount ?? 0), mark: markOf(n.mark) });
  for (const p of day.penalties ?? []) rows.push({ kind: "p", l: "Штраф", sub: (p.reason ?? "").slice(0, 48) || undefined, r: `−${money(Math.abs(p.amount ?? 0))}`, mark: markOf(p.mark) });
  return rows;
}

export async function renderPayslip(sal: PsSal, meta: PsMeta): Promise<Blob> {
  await (document.fonts?.ready ?? Promise.resolve());
  const P = palette();
  const days = Object.entries(sal.days ?? {}).sort(([a], [b]) => a.localeCompare(b)).map(([d, day]) => ({ d, day, rows: dayRows(day) })).filter((x) => x.rows.length);
  const parts: [string, number, string][] = [
    ["ИГРЫ", sal.quest_earnings, P.gold], ["МК", sal.mc_earnings, P.mc], ["АДМИНСТВО", sal.hall_admin_earnings, P.pink],
    ["ДОПРАБОТЫ", sal.extra_work_earnings, P.purple], ["ТАКСИ", sal.taxi_earnings, P.cyan], ["ПОКУПКИ", sal.purchase_total ?? 0, P.buy],
    ["ПРЕМИИ", sal.bonus_total ?? 0, P.bonus],
  ];
  const partsShown = parts.filter(([, v]) => (v || 0) > 0);
  if ((sal.penalty_total ?? 0) > 0) partsShown.push(["ШТРАФЫ", -(sal.penalty_total ?? 0), P.red]);

  /* высота: шапка 470 + разбивка + дни (шапка дня 54 + строка 46/62 с подписью) + футер 120 */
  const ROW = (r: Row) => (r.sub ? 62 : 46);
  const carry = Math.round(sal.carry ?? 0);
  let H = 470 + Math.ceil(partsShown.length / 2) * 72 + 40 + (carry ? 236 : 0);
  for (const x of days) H += 54 + x.rows.reduce((a, r) => a + ROW(r), 0) + 26;
  H += 130;

  const cv = document.createElement("canvas"); cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d")!;
  /* фон + сетка + свечения */
  ctx.fillStyle = P.bg; ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = P.s3; ctx.globalAlpha = 0.35; ctx.lineWidth = 1;
  for (let x = 0; x <= W; x += 40) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke(); }
  for (let y = 0; y <= H; y += 40) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke(); }
  ctx.globalAlpha = 1;
  const glow = (x: number, y: number, r: number, c: string) => { const g = ctx.createRadialGradient(x, y, 0, x, y, r); g.addColorStop(0, c); g.addColorStop(1, "rgba(0,0,0,0)"); ctx.globalAlpha = 0.22; ctx.fillStyle = g; ctx.fillRect(x - r, y - r, r * 2, r * 2); ctx.globalAlpha = 1; };
  glow(120, 140, 520, P.cyan); glow(W - 80, H - 120, 560, P.pink);
  /* скан-линии */
  ctx.globalAlpha = 0.07; ctx.fillStyle = P.t1;
  for (let y = 0; y < H; y += 6) ctx.fillRect(0, y, W, 1);
  ctx.globalAlpha = 1;
  /* рамка + угловые скобки */
  ctx.strokeStyle = P.cyan; ctx.globalAlpha = 0.55; ctx.lineWidth = 2; ctx.strokeRect(24, 24, W - 48, H - 48); ctx.globalAlpha = 1;
  const bracket = (x: number, y: number, sx: number, sy: number) => { ctx.strokeStyle = P.cyan; ctx.lineWidth = 6; ctx.beginPath(); ctx.moveTo(x, y + 44 * sy); ctx.lineTo(x, y); ctx.lineTo(x + 44 * sx, y); ctx.stroke(); };
  bracket(24, 24, 1, 1); bracket(W - 24, 24, -1, 1); bracket(24, H - 24, 1, -1); bracket(W - 24, H - 24, -1, -1);
  /* глитч-полосы */
  ctx.globalAlpha = 0.5; ctx.fillStyle = P.pink; ctx.fillRect(W - 300, 60, 180, 4); ctx.fillStyle = P.cyan; ctx.fillRect(W - 240, 70, 90, 3); ctx.globalAlpha = 1;

  const text = (s: string, x: number, y: number, font: string, color: string, align: CanvasTextAlign = "left", shadow?: string) => {
    ctx.font = font; ctx.fillStyle = color; ctx.textAlign = align; ctx.textBaseline = "alphabetic";
    if (shadow) { ctx.shadowColor = shadow; ctx.shadowBlur = 24; } else ctx.shadowBlur = 0;
    ctx.fillText(s, x, y); ctx.shadowBlur = 0;
  };
  const clip = (s: string, font: string, maxW: number) => { ctx.font = font; if (ctx.measureText(s).width <= maxW) return s; let t = s; while (t.length > 1 && ctx.measureText(`${t}…`).width > maxW) t = t.slice(0, -1); return `${t}…`; };

  /* шапка */
  let y = PAD + 30;
  text("UNIBOOKING  //  OFFICE OF OPERATIONS", PAD, y, `700 20px ${F.meta}`, P.cyan, "left", P.cyan);
  y += 66; text("РАСЧЁТКА", PAD, y, `900 64px ${F.display}`, P.t1, "left", P.cyan);
  y += 40; text(`${dLabel(meta.from).slice(0, 5)} — ${dLabel(meta.to).slice(0, 5)}`, PAD, y, `600 26px ${F.meta}`, P.t2);
  y += 62; text(clip(sal.name.toUpperCase(), `800 44px ${F.display}`, W - PAD * 2), PAD, y, `800 44px ${F.display}`, P.gold, "left", P.orange);
  /* итог */
  y += 34; ctx.fillStyle = P.s1; ctx.globalAlpha = 0.9; ctx.fillRect(PAD, y, W - PAD * 2, 118); ctx.globalAlpha = 1;
  ctx.fillStyle = P.gold; ctx.fillRect(PAD, y, 6, 118);
  text("К ВЫПЛАТЕ", PAD + 26, y + 40, `600 20px ${F.meta}`, P.t2);
  text(money(sal.total), W - PAD - 24, y + 88, `900 60px ${F.display}`, P.gold, "right", P.orange);
  text(`${sal.games_count} игр`, PAD + 26, y + 88, `600 26px ${F.body}`, P.t1);
  y += 118 + 30;
  /* 16.10: холд с прошлых недель и «к выдаче» = к выплате + холд (выдача в пятницу — за прошлую неделю) */
  if (carry) {
    const c = carry > 0 ? P.green : P.red;
    ctx.fillStyle = P.s1; ctx.fillRect(PAD, y, W - PAD * 2, 92); ctx.fillStyle = c; ctx.fillRect(PAD, y, 6, 92);
    text("ХОЛД С ПРОШЛЫХ НЕДЕЛЬ", PAD + 26, y + 36, `600 20px ${F.meta}`, P.t2);
    text(carry > 0 ? "мы вам должны" : "вы нам должны", PAD + 26, y + 70, `600 24px ${F.body}`, P.t1);
    text(`${carry > 0 ? "+" : "−"}${money(Math.abs(carry))}`, W - PAD - 24, y + 62, `800 40px ${F.display}`, c, "right");
    y += 92 + 20;
    ctx.strokeStyle = P.gold; ctx.lineWidth = 3; ctx.strokeRect(PAD + 1.5, y + 1.5, W - PAD * 2 - 3, 100);
    const give = sal.total + carry;   // отрицательной не бывает: долг переносится на следующую неделю
    text("К ВЫДАЧЕ", PAD + 26, y + 46, `700 24px ${F.meta}`, P.gold);
    if (give < 0) text(`долг −${money(-give)} переносится`, PAD + 26, y + 80, `600 20px ${F.body}`, P.red);
    text(money(Math.max(0, give)), W - PAD - 24, y + 70, `900 52px ${F.display}`, P.gold, "right", P.orange);
    y += 100 + 24;
  }
  /* разбивка 2 колонки */
  const colW = (W - PAD * 2 - 20) / 2;
  partsShown.forEach(([l, v, c], i) => {
    const cx = PAD + (i % 2) * (colW + 20); const cy = y + Math.floor(i / 2) * 72;
    ctx.fillStyle = P.s2; ctx.fillRect(cx, cy, colW, 58); ctx.fillStyle = c; ctx.fillRect(cx, cy, 5, 58);
    text(l, cx + 20, cy + 37, `600 20px ${F.meta}`, P.t2);
    text(v < 0 ? `−${money(-v)}` : money(v), cx + colW - 18, cy + 39, `700 28px ${F.display}`, v < 0 ? P.red : P.t1, "right");
  });
  y += Math.ceil(partsShown.length / 2) * 72 + 40;

  /* 26.10: отмеченная строка — рамка со свечением её цвета и плашка подписи справа от названия */
  const markFrame = (r: Row, y0: number, h: number, c: string) => {
    ctx.save();   // состояние холста (толщина, тень, прозрачность) — только на эту строку (ревью 26.10: линия футера толстела)
    try { markDraw(r, y0, h, c); } finally { ctx.restore(); }
  };
  const markDraw = (r: Row, y0: number, h: number, c: string) => {
    ctx.strokeStyle = c; ctx.lineWidth = 2; ctx.shadowColor = c; ctx.shadowBlur = 18;
    ctx.strokeRect(PAD + 1, y0 + 1, W - PAD * 2 - 2, h - 8); ctx.shadowBlur = 0;
    if (!r.mark) return;
    const font = `700 17px ${F.meta}`; ctx.font = `600 26px ${F.body}`;
    const x0 = PAD + 20 + ctx.measureText(`★ ${r.l}`).width + 16, room = W - PAD - 220 - x0;
    if (room < 60) return;
    const label = clip(r.mark.toUpperCase(), font, room - 20); ctx.font = font;
    const w = ctx.measureText(label).width + 20;
    ctx.globalAlpha = 0.16; ctx.fillStyle = c; ctx.fillRect(x0, y0 + 9, w, 28); ctx.globalAlpha = 1;
    ctx.strokeStyle = c; ctx.lineWidth = 1.5; ctx.strokeRect(x0 + 0.75, y0 + 9.75, w - 1.5, 26.5);
    text(label, x0 + 10, y0 + 29, font, c);
  };
  /* дни */
  const colorOf: Record<Row["kind"], string> = { q: P.gold, t: P.cyan, m: P.mc, a: P.pink, e: P.purple, b: P.buy, n: P.bonus, p: P.red };
  for (const x of days) {
    text(dLabel(x.d).toUpperCase(), PAD, y + 34, `700 24px ${F.display}`, P.cyan);
    text(money(x.day.day_total ?? 0), W - PAD, y + 34, `700 26px ${F.display}`, P.gold, "right");
    ctx.strokeStyle = P.s3; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(PAD, y + 46); ctx.lineTo(W - PAD, y + 46); ctx.stroke();
    y += 54;
    for (const r of x.rows) {
      const h = ROW(r); const c = colorOf[r.kind]; const marked = r.mark !== undefined;
      ctx.fillStyle = c; ctx.globalAlpha = r.kind === "t" ? 0.06 : marked ? 0.2 : 0.1; ctx.fillRect(PAD, y, W - PAD * 2, h - 6); ctx.globalAlpha = 1;
      ctx.fillStyle = c; ctx.fillRect(PAD, y, marked ? 8 : 4, h - 6);
      if (marked) markFrame(r, y, h, c);
      const indent = r.kind === "t" ? 44 : 20;
      const title = marked ? `★ ${r.l}` : r.l;
      text(clip(title, `600 26px ${F.body}`, W - PAD * 2 - 220), PAD + indent, y + 31, `600 26px ${F.body}`, marked ? c : r.kind === "p" ? P.red : P.t1, "left", marked ? c : undefined);
      if (r.sub) text(clip(r.sub, `500 20px ${F.body}`, W - PAD * 2 - 220), PAD + indent, y + 54, `500 20px ${F.body}`, r.warn ? P.orange : P.t3);
      text(r.r, W - PAD - 16, y + 32, `700 26px ${F.display}`, r.kind === "p" ? P.red : r.kind === "n" ? P.bonus : P.t1, "right");
      y += h;
    }
    y += 26;
  }
  /* футер */
  ctx.strokeStyle = P.s3; ctx.beginPath(); ctx.moveTo(PAD, y + 10); ctx.lineTo(W - PAD, y + 10); ctx.stroke();
  text(`Сформировано ${meta.issuedAt} · ${meta.issuedBy}`, PAD, y + 48, `500 20px ${F.meta}`, P.t3);
  text("ВОПРОСЫ ПО ЦИФРАМ — В ОПЕРАЦИОННЫЙ ОФИС", PAD, y + 80, `600 18px ${F.meta}`, P.t3);
  text("UB", W - PAD, y + 80, `900 40px ${F.display}`, P.cyan, "right", P.cyan);

  return new Promise<Blob>((resolve, reject) => cv.toBlob((b) => (b ? resolve(b) : reject(new Error("toBlob"))), "image/png"));
}
